import React from "react";
import PropTypes from "prop-types";

import {
  Notification,
  NotificationStatuses,
} from "@jsainsburyplc/id-ui-common";

import { FAILURE_MESSAGE } from "constants/messages";
import {
  INVALID_RESET_PASSWORD_TOKEN,
  INCORRECT_PASSWORD_CHOSEN,
} from "constants/codes";

const ResetPasswordError = ({ errorCode }) => {
  return (
    <div className="ln-u-text-align-center ln-u-margin-bottom*2">
      <Notification type={NotificationStatuses.ERROR_TYPE}>
        <div>
          {(() => {
            switch (errorCode) {
              case INCORRECT_PASSWORD_CHOSEN:
                return `Please check your password doesn't contain your name, email and it's not your previous password.`;
              case INVALID_RESET_PASSWORD_TOKEN:
                return "Your password reset session has expired. Please start the session again to reset your password.";
              default:
                return FAILURE_MESSAGE;
            }
          })()}
        </div>
      </Notification>
    </div>
  );
};

ResetPasswordError.propTypes = {
  errorCode: PropTypes.number,
};

export default ResetPasswordError;
